import React, { useState } from "react";
import "../../Components/text.css";
import "../../../src/App.css";
import ins1image from "../../Assets/Images/INsights/img_blog1.jpg";
import ins2image from "../../Assets/Images/INsights/insight2.png";

function Datalabel({ Title, shortParagraph, fullParagraph, image }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "2rem",
        marginBottom: "2.5rem",
      }}
    >
      {/* Text Section */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <p
          className="maintext"
          style={{
            marginTop: "3%",
            fontSize: 18.8,
            fontWeight: "bold",
            fontFamily: "Arial",
            color: "#4F9685",
          }}
        >
          {Title}
        </p>

        <p
          className="smalltext"
          style={{
            color: "#",
            fontWeight: "normal",
            fontSize: 16,
            marginTop: "1%",
            fontFamily: "Arial",
            lineHeight: "1.6",
          }}
        >
          {isExpanded ? fullParagraph : shortParagraph}
          {!isExpanded && (
            <span
              onClick={() => setIsExpanded(true)}
              style={{
                color: "#0D1C17",
                fontWeight: "600",
                cursor: "pointer",
                marginLeft: "4px",
              }}
            >
             
            </span>
          )}
        </p>

        {/* Custom Read More Button */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            marginTop: "1rem",
            padding: "10px 24px",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Arial, sans-serif",
            color: "#0D1C17",
            backgroundColor: "#E8F2F0",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            outline: "none",
            transition: "all 0.2s ease",
          }}
        >
          {isExpanded ? "Show Less" : "Read More"}
        </button>
      </div>

      {/* Image Section */}
      <div
        style={{
          width: "320px",
          height: "171px",
          borderRadius: "8px",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src={image}
          alt={Title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  );
}

export default function Insights() {
  const Data = [
    {
      img: ins1image,
      title: "The SLAMDAM: Mobile Flood Defense",
      shortParagraph:
        "The SLAMDAM, also known as the mobile dam, is an innovative and low-cost technological solution to enhance resilience against floods...",
      fullParagraph:
        "The SLAMDAM, also known as the mobile dam is an innovative and low-cost technological solution to enhance resilience against floods. This technological solution is a mobile emergency barrier, which can easily be deployed when there is a threat of flooding. SLAMDAM’s unique design and material enable an exceptionally flexible solution for the emergency dam and water retention market.",
    },
    {
      img: ins2image,
      title: "Water Conservation Strategies for Businesses",
      shortParagraph:
        "Discover effective strategies to reduce water consumption and promote water conservation in your business...",
      fullParagraph:
        "Discover effective strategies to reduce water consumption and promote water conservation in your business. From smart metering to employee engagement programs, businesses can significantly reduce their water footprint while contributing to global sustainability goals. Learn how small changes can lead to big savings and environmental impact.",
    },
  ];

  return (
    <div
      style={{
        width: "75%",
        maxWidth: "1200px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "2rem 0",
      }}
    >
      <p
        className="maintext"
        style={{
          fontSize: 36,
          fontWeight: "bold",
          fontFamily: "Arial",
          color: "#111827",
          marginBottom: "2rem",
        }}
      >
        Latest Insights
      </p>

      {Data.map((item, index) => (
        <Datalabel
          key={index}
          Title={item.title}
          image={item.img}
          shortParagraph={item.shortParagraph}
          fullParagraph={item.fullParagraph}
        />
      ))}
    </div>
  );
}